/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


/**
* Properties of an AWS Keyspaces (Cassandra) table. Present only when `resourceType` is set to `AWS_KEYSPACES_TABLE`. 
*/
export class AwsKeyspacesResource {
  /**
  * Name of the keyspace containing this table.
  */
  'keyspaceName'?: string;
  /**
  * Name of the table.
  */
  'tableName'?: string;
  /**
  * CDC (Change Data Capture) status of the table.
  */
  'cdcStatus'?: AwsKeyspacesResourceCdcStatusEnum;
  /**
  * CDC view type for the table.
  */
  'cdcViewType'?: AwsKeyspacesResourceCdcViewTypeEnum;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "keyspaceName",
      "baseName": "keyspaceName",
      "type": "string",
      "format": ""
    },
    {
      "name": "tableName",
      "baseName": "tableName",
      "type": "string",
      "format": ""
    },
    {
      "name": "cdcStatus",
      "baseName": "cdcStatus",
      "type": "AwsKeyspacesResourceCdcStatusEnum",
      "format": ""
    },
    {
      "name": "cdcViewType",
      "baseName": "cdcViewType",
      "type": "AwsKeyspacesResourceCdcViewTypeEnum",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return AwsKeyspacesResource.attributeTypeMap;
  }

  public constructor() {
  }
}


export enum AwsKeyspacesResourceCdcStatusEnum {
  Enabled = 'CDC_ENABLED',
  Disabled = 'CDC_DISABLED',
  Enabling = 'CDC_ENABLING',
  Disabling = 'CDC_DISABLING'
}
export enum AwsKeyspacesResourceCdcViewTypeEnum {
  NewImage = 'NEW_IMAGE',
  OldImage = 'OLD_IMAGE',
  KeysOnly = 'KEYS_ONLY',
  NewAndOldImages = 'NEW_AND_OLD_IMAGES'
}

